import React, { useState } from "react";
import { FaPlay } from "react-icons/fa6";
import { FaForwardStep } from "react-icons/fa6";

const IntroductionVideo = ({
  currentStep,
  setCurrentStep,
  setUsername,
  handleSendMessage,
  introMessage,
}) => {
  const [username, setLocalUsername] = useState("");

  const handleSkip = () => {
    setCurrentStep(introMessage.length - 1);
  };

  const handleSend = () => {
    if (!username.trim()) {
      alert("Please enter your name before proceeding.");
      return;
    }
    setUsername(username);
    handleSendMessage(`Hi, my name is ${username}`);
    setCurrentStep((prevStep) =>
      Math.min(prevStep + 1, introMessage.length - 1)
    );
  };

  return (
    <div className="hospital__introduction-popup">
      <p className="hospital__popup-message">{introMessage[currentStep]}</p>
      {currentStep === introMessage.length - 1 && (
        <div className="container__name-input">
          <input
            id="name-input"
            type="text"
            placeholder="enter your name..."
            value={username}
            onChange={(e) => setLocalUsername(e.target.value)}
          />
          <div className="send-button" onClick={handleSend}>
            <FaPlay />
          </div>
        </div>
      )}
      {currentStep < introMessage.length - 1 && (
        <button className="skip-button" onClick={handleSkip}>
          <FaForwardStep />
          Skip
        </button>
      )}
    </div>
  );
};

export default IntroductionVideo;
